/* import __COLOCATED_TEMPLATE__ from './pro-trial-countdown-banner.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { PERFORMANCE_PRO_ID } from 'embercom/lib/billing';
import type AppService from 'embercom/services/app-service';
import type IntlService from 'embercom/services/intl';

const MAX_DAYS_TO_SHOW_BANNER = 50;

interface Signature {
  Element: HTMLDivElement;
  Args: {};
}

export default class ProTrialCountdownBanner extends Component<Signature> {
  @service declare appService: AppService;
  @service declare customerService: $TSFixMe;
  @service declare intercomEventService: $TSFixMe;
  @service declare intl: IntlService;

  constructor(owner: unknown, args: Signature['Args']) {
    super(owner, args);
    if (this.shouldShowBanner) {
      this.intercomEventService.trackAnalyticsEvent({
        action: 'viewed',
        object: 'pro_trial_countdown_banner',
      });
    }
  }

  get performanceProProduct() {
    let products = this.customerService.products ?? [];
    return products.find(
      (product: $TSFixMe) => String(product.get('id')) === String(PERFORMANCE_PRO_ID),
    );
  }

  get shouldShowBanner(): boolean {
    let product = this.performanceProProduct;
    return (
      !!product &&
      product.get('isOnTrial') &&
      !product.get('billableCustomerPlan') &&
      this.appService.app.canSeeAiInsightsAddon &&
      this.daysRemaining <= MAX_DAYS_TO_SHOW_BANNER
    );
  }

  get daysRemaining(): number {
    return this.performanceProProduct?.daysToTrialExpiration ?? 0;
  }

  get title(): string {
    let days = this.daysRemaining;
    if (days === 0) {
      return this.intl.t('ai-agent.settings.pro-trial-countdown-banner.title-today');
    }
    if (days === 1) {
      return this.intl.t('ai-agent.settings.pro-trial-countdown-banner.title-one-day');
    }
    return this.intl.t('ai-agent.settings.pro-trial-countdown-banner.title', {
      daysRemaining: days,
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Banners::ProTrialCountdownBanner': typeof ProTrialCountdownBanner;
    'banners/pro-trial-countdown-banner': typeof ProTrialCountdownBanner;
  }
}
